module.exports = __webpack_public_path__ + "static/media/betconstruct_poker.683a332e.svg";